import React, { ButtonHTMLAttributes } from 'react';
import './Button.scss';

/**
 * Button Component
 * Reusable button with different variants
 */

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'danger';
  size?: 'small' | 'medium' | 'large';
  loading?: boolean;
  fullWidth?: boolean;
}

const Button: React.FC<ButtonProps> = ({
  children,
  variant = 'primary',
  size = 'medium',
  loading = false,
  fullWidth = false,
  disabled,
  className = '',
  ...props
}) => {
  const buttonClass = `
    button 
    button--${variant} 
    button--${size} 
    ${fullWidth ? 'button--full-width' : ''} 
    ${loading ? 'button--loading' : ''} 
    ${className}
  `.trim();

  return (
    <button
      className={buttonClass}
      disabled={disabled || loading}
      {...props}
    >
      {loading ? (
        <span className="button__loader"></span>
      ) : (
        children
      )}
    </button>
  );
};

export default Button;

